import { Box, Typography } from "@mui/material";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";

export default function ContactStrip() {
  const { t } = useTranslation("heropage");
  const contacts = t("contactStrip.contacts", { returnObjects: true });

  return (
    <Box
      sx={{
        position: "relative",
        mx: { xs: 2.5, md: 6 },
        my: { xs: 10, md: 14 },
        borderRadius: "28px",
        overflow: "hidden",
        backgroundColor: "#050508",
        boxShadow: "0 40px 120px rgba(0,0,0,0.6)",
      }}
    >
      {/* BASE DARK GRADIENT */}
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          background:
            "linear-gradient(120deg, #050508 0%, #0B0E1E 45%, #14162C 75%, #06060F 100%)",
          zIndex: 0,
        }}
      />

      {/* ANIMATED WAVE */}
      <motion.div
        animate={{ backgroundPositionX: ["0%", "100%"] }}
        transition={{
          duration: 22,
          repeat: Infinity,
          ease: "linear",
        }}
        style={{
          position: "absolute",
          inset: 0,
          background:
            "linear-gradient(90deg, rgba(120,90,255,0.12), rgba(255,255,255,0.05), rgba(120,90,255,0.12))",
          backgroundSize: "200% 100%",
          zIndex: 1,
        }}
      />

      {/* CONTENT */}
      <Box
        sx={{
          position: "relative",
          zIndex: 2,
          px: { xs: 4, md: 8 },
          py: { xs: 6, md: 7 },
          maxWidth: 900,
        }}
      >
        <Typography
          sx={{
            fontFamily: "Playfair Display",
            fontSize: { xs: "1.8rem", md: "2.3rem" },
            color: "#FFFFFF",
            mb: 2,
          }}
        >
          {t("contactStrip.title")}
        </Typography>

        <Typography
          sx={{
            fontFamily: "Inter",
            fontSize: "0.95rem",
            lineHeight: 1.9,
            color: "rgba(255,255,255,0.75)",
            mb: 4,
            maxWidth: 520,
          }}
        >
          {t("contactStrip.description")}
        </Typography>

        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
            gap: 3,
          }}
        >
          {contacts.map((item) => (
            <Box
              key={item.email}
              component="a"
              href={`mailto:${item.email}`}
              sx={{
                textDecoration: "none",
                borderRadius: "18px",
                px: 3,
                py: 2.5,
                background:
                  "linear-gradient(135deg, rgba(255,255,255,0.06), rgba(255,255,255,0.02))",
                border: "1px solid rgba(255,255,255,0.08)",
                transition: "all 0.35s ease",
                cursor: "pointer",
                "&:hover": {
                  background:
                    "linear-gradient(135deg, rgba(255,255,255,0.1), rgba(255,255,255,0.04))",
                  transform: "translateY(-2px)",
                },
              }}
            >
              <Typography
                sx={{
                  fontFamily: "Inter",
                  fontSize: "0.75rem",
                  letterSpacing: "0.14em",
                  color: "rgba(255,255,255,0.55)",
                  mb: 0.8,
                  textTransform: "uppercase",
                }}
              >
                {item.label}
              </Typography>

              <Typography
                sx={{
                  fontFamily: "Inter",
                  fontSize: "0.95rem",
                  color: "#FFFFFF",
                  wordBreak: "break-all",
                }}
              >
                {item.email}
              </Typography>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
}
